import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports
import type { PayloadAction } from "@reduxjs/toolkit";
import type { PartnerHandoverLoginEndpointResponseDto } from "@src/api-new/generated-api.schemas";

import type { ChangePhoneNumberFormSubmitPayload } from "@src/components/ChangePhoneNumber/ChangePhoneNumber.types";
import type { ResendOtpFormSubmitPayload } from "@src/components/ResendOtpForm/ResendOtp.types";

import type { HandoverOtpValidateFormSubmitPayload } from "./Handover.types";

interface HandoverState {
  affiliateDetails: PartnerHandoverLoginEndpointResponseDto;
  initialPin: string;
}

export const initialState: HandoverState = {
  affiliateDetails: {},
  initialPin: ""
};

const handoverSlice = createSlice({
  name: "handover",
  initialState,
  reducers: {
    passAffiliateDetails(state, action: PayloadAction<PartnerHandoverLoginEndpointResponseDto>) {
      state.affiliateDetails = action.payload;
    },
    setInitialPin(state, action: PayloadAction<string>) {
      state.initialPin = action.payload;
    },
    handoverCompletedInOtherTab(state) {
      return state;
    },
    submitChangePhoneNumberForm(state, action: PayloadAction<ChangePhoneNumberFormSubmitPayload>) {
      return state;
    },
    submitOtpValidateForm(state, action: PayloadAction<HandoverOtpValidateFormSubmitPayload>) {
      return state;
    },
    resendOtp(state, action: PayloadAction<ResendOtpFormSubmitPayload>) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});

export default handoverSlice.reducer;
export const {
  passAffiliateDetails,
  setInitialPin,
  handoverCompletedInOtherTab,
  submitChangePhoneNumberForm,
  submitOtpValidateForm,
  resendOtp,
  destroy
} = handoverSlice.actions;
export const handoverActions = handoverSlice.actions;
